import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import config from './config/config';


i18n
    .use(XHR)
    .init({
        fallbackLng: 'de',
        debug: false,
        defaultNS: 'backend',

        interpolation: {
            escapeValue: false, // not needed for react!!
        },

        // react i18next special options (optional)
        react: {
            wait: false,
            bindI18n: 'languageChanged loaded',
            bindStore: 'added removed',
            nsMode: 'default'
        },

        backend: {
            loadPath: config.server.endpoint + 'translation/{{ns}}/{{lng}}',
            allowMultiLoading: false,
            crossDomain: true,
            withCredentials: false,
        }
    });


export default i18n;
